import { render, staticRenderFns } from "./ProfileEditTabHistory.vue?vue&type=template&id=12ba5fce&scoped=true&"
import script from "./ProfileEditTabHistory.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabHistory.vue?vue&type=style&index=0&id=12ba5fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba5fce",
  null
  
)

export default component.exports